import { useCallback } from "react";

import { useTranslation } from "next-i18next";

import { analyticsService } from "@/common/services/analytics/analytics.service";
import { ProductCard } from "@/features/search/components/product-card/ProductCard";
import { toCardProduct } from "@/features/search/utils/gateway-product.utils";
import { useContentLocale } from "@/i18n/hooks";
import useSearchProducts from "@whoppah/apollo/hooks/useSearchProducts";

const LIST_NAME = "blog-products-list";

const BlogProducts = ({ search }) => {
  const { t } = useTranslation();
  const contentLocale = useContentLocale();
  const { data, loading } = useSearchProducts({
    variables: {
      ...search,
      pageSize: 4,
      lang: contentLocale.toUpperCase(),
    },
  });

  const products = data?.searchProducts?.items;
  const searchMeta = {
    queryId: data?.searchProducts?.queryID ?? undefined,
    indexName: data?.searchProducts?.indexName ?? undefined,
    page: data?.searchProducts?.pagination?.page,
    limit: data?.searchProducts?.pagination?.limit,
  };

  /** Track `view_item_list` event. */
  analyticsService.useExecAfterMount(
    useCallback(() => {
      if (!loading) {
        analyticsService.trackViewItemList(
          "blog_products",
          "blog_products",
          products
        );
      }
    }, [products, loading])
  );

  if (products?.length === 0 || loading) {
    return null;
  }

  return (
    <section>
      <h3 className="mb-[24px] font-poppins text-[24px] font-semibold md:text-[30px]">
        {t("blog:blog-shop-items")}
      </h3>
      <div className="grid grid-cols-2 gap-[24px] md:grid-cols-4">
        {products?.map((product, index) => (
          <ProductCard
            key={product.id}
            product={toCardProduct(product)}
            onSelect={() =>
              analyticsService.trackSelectItem(
                index + 1,
                LIST_NAME,
                LIST_NAME,
                product,
                searchMeta
              )
            }
          />
        ))}
      </div>
    </section>
  );
};

export default BlogProducts;
